// extracted by mini-css-extract-plugin
export default {"root":"Header_root__jiUBv","left":"Header_left__AgymK","logo":"Header_logo__shVBB","title":"Header_title__l+wMf"};